import React, { useState, useEffect } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../../components/MaterialButton";
import colors from "../../../assest/theme/base/colors";
import { Box, Dialog } from "@mui/material";
import DynamicTableProps from "../../Utils/DynamicTableProps";
import AddPositionMaster from "./addposition";
import ConfirmDialog from "../../Utils/ConfirmDialog";
import { Getalluserdetail, Deleteuser } from "../UserMaster/mutation";
import { getallpostion, deleteposition } from "../PositionMaster/mutation";
import { fetchAll, deleteItem, FetchDataGet } from "../../../BaseUrl";
import MessagePopup from "../../Utils/MessagePopup";
import ExportDialog from "../../Utils/ExportDialog";
import LoadingSpinner from "../../loader/loadercomp";
import AccessComponent from "../../Utils/AccessComponent";

function PositionMaster() {
  const [open, setOpen] = useState(false);
  const [view, setview] = useState(false);
  const [searchdata, setsearchdata] = useState("");
  const [sortedvalue, setsortedvalue] = useState("");
  const [editeddata, setEditeddata] = useState([]);
  const [editedtrue, setEditedtrue] = useState(false);
  const [dialogData, setDialogData] = useState({
    title: "",
    content: "",
    onConfirm: () => {},
  });
  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [userlist, setuserlist] = useState([]);
  const [openExport, setOpenExport] = useState(false);
  const [Loader, setLoader] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [serverPage, setServerPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [prevSearch, setPrevSearch] = useState("");

  const columns = [
    { label: "Position Name", field: "positionName" },
    { label: "Created By", field: "createdBy" },
    { label: "Client Name", field: "clientName" },
    { label: "Actions", field: "actions" },
  ];

  const validIndustryData = Array.isArray(userlist) ? userlist : [];

  const sortedData = [...validIndustryData].sort((a, b) => {
    const sortOption = sortedvalue?.value || "descending"; // default to descending
    switch (sortOption) {
      case "ascending":
        return new Date(a.createdAt) - new Date(b.createdAt);
      case "descending":
        return new Date(b.createdAt) - new Date(a.createdAt);
      default:
        return validIndustryData; // default to descending
    }
  });

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      let currentPage = serverPage;
      if (searchdata !== prevSearch) {
        setServerPage(1);
        currentPage = 1;
        setPrevSearch(searchdata);
      }
      getALluserdetail(currentPage, searchdata);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchdata, serverPage]);

  useEffect(() => {
    if (!open) {
      getALluserdetail(serverPage, searchdata);
    }
  }, [open]);

  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const exportClose = () => {
    setOpenExport(false);
  };

  const formClose = () => {
    setOpen(false);
    getALluserdetail(serverPage, searchdata);
    setview(false);
  };
  const addRole = () => {
    setOpen(true);
  };

  const onView = (id) => {
    let data = userlist.filter((x) => x.id === id);
    setEditeddata(data);
    setEditedtrue(true);
    setOpen(true);
    setview(true);
  };

  const onEdit = (id) => {
    let data = userlist.filter((x) => x.id === id);
    setEditeddata(data);
    setEditedtrue(true);
    setOpen(true);
  };

  const deletelist = (id) => {
    handleOpenDialog();
    setDialogData({
      title: "Are you sure you want to delete this records ?",
      content: `If you delete the field you can’t recover it`,
      onConfirm: () => deleteconfirm(id),
      onClose: () => deletecancel(),
    });
  };

  const deleteconfirm = async (id) => {
    try {
      const variables = {
        input: {
          id: id,
        },
      };
      const response = await deleteItem(deleteposition, variables);

      if (response.deletePosition.success == true) {
        setPopup({
          open: true,
          message: response.deletePosition.message,
          severity: "success",
        });
        deletecancel();
        getALluserdetail(serverPage, searchdata);
      } else {
        setPopup({
          open: true,
          message: response.deletePosition.message,
          severity: "error",
        });
        deletecancel();
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const deletecancel = () => {
    setDialogOpen(false);
    setDialogData({
      ...dialogData,
      title: "",
      content: "",
      onConfirm: () => {},
    });
  };

  //open and close dialog for confirmation
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const getALluserdetail = async (page = serverPage, search = searchdata) => {
    setLoader(true);
    try {
      const variables = {
        search: search,
        page: page,
        pageSize: 10,
      };
      const response = await FetchDataGet(getallpostion, variables);
      if (response?.getAllPositions?.success === true) {
        setTotalCount(response?.getAllPositions?.totalCount || 0);
        const data = response?.getAllPositions?.data || [];
        const formateData = data.map((item) => ({
          id: item.id,
          positionName: item.positionName || "N/A",
          clientName: item.client ? item.client.clientName : "N/A",
          clientId: item.client ? item.client.id : "N/A",
          createdBy: item.createdBy || "N/A",
          createdAt: formatDate(item.createdAt) || "N/A",
          lastUpdate: formatDate(item.lastUpdate) || "N/A",
          updatedBy: item.updatedBy || "N/A",
        }));
        setuserlist(formateData);
      } else {
        setuserlist([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <DashboardLayout
      searchdata={searchdata}
      setsearchdata={setsearchdata}
      setOpenExport={setOpenExport}
      name="Position Master"
    >
      {Loader && <LoadingSpinner />}
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <ConfirmDialog
        open={dialogOpen}
        title={dialogData.title}
        content={dialogData.content}
        onClose={handleCloseDialog}
        onConfirm={dialogData.onConfirm}
      />
      <ExportDialog
        open={openExport}
        onClose={exportClose}
        setPopup={setPopup}
        data={sortedData}
        fileName="Position"
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end", width: "98%" }}>
        <AccessComponent name="Position Master" action="Create">
          <MaterialButton
            variant="contained"
            onClick={() => {
              addRole();
            }}
            sx={{
              background: colors.buttonColor,
              color: "#fff",
              textTransform: "capitalize",
            }}
          >
            + Add Position
          </MaterialButton>
        </AccessComponent>
        <Dialog
          open={open}
          sx={{
            "& .MuiDialog-paper": {
              width: "800px", // Set your desired width
              maxWidth: "none", // Prevent it from limiting the width to default sizes
              height:'500px'
            },
          }}
        >
          <AddPositionMaster
            formClose={formClose}
            editeddata={editeddata}
            editedtrue={editedtrue}
            setEditedtrue={setEditedtrue}
            view={view}
          />
        </Dialog>
      </Box>
      <DynamicTableProps
        columns={columns}
        rows={sortedData}
        onView={onView}
        onEdit={onEdit}
        onDelete={deletelist}
        name="Position Master"
        serverPage={serverPage}
        totalCount={totalCount}
        onPageChange={(event, newPage) => setServerPage(newPage)}
      />
    </DashboardLayout>
  );
}

export default PositionMaster;
